import { getQuery, getLimitOptions } from 'utilities/query';
import templateUrl from './noncompliant-members.html';

export default {
  templateUrl,
  bindings: {
    companies: '<'
  },
  controller: class NoncompliantMembersComponent {
    constructor($mdDialog, EventEmitter) {
      'ngInject';

      Object.assign(this, { $mdDialog, EventEmitter });
    }

    $onInit() {
      this.query = getQuery();
      this.limitOptions = getLimitOptions();
    }

    getIcon(bool) {
      if (bool) {
        return 'check';
      }

      return 'close';
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/admin/member-compliance/noncompliant-members/noncompliant-members.component.js